import { createAction } from 'redux-actions';
import * as constants from './constants';
export const setFeatures = createAction(constants.SET_FEATURES);
export const setPrivateFeaturesLoaded = createAction(constants.SET_IS_AUTHENTICATED_FEATURES_LOADED);
